import { colleagueSchema } from '../StateSchema'

export function isValidContact(contact) {
  if (!contact) return false
  const { firstname, email } = contact
  if (!firstname || !email) return false
  return colleagueSchema.isValidSync(contact)
}
